import React, { useState } from "react";
import "./index.scss";
import { faqData } from "./Faq.constants";
import { useTranslation } from "react-i18next";

const FAQ = ({ onScrollToPack }) => {
  const [faqs, setFaqs] = useState(faqData);
  const { t } = useTranslation();

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h1 className="faq-title mt-3">{t("home.faq_title")}</h1>
        </div>
        <div className="faqs">
          {faqs.map((faq, index) => (
            <div
              className={"faq " + (faq.open ? "open" : "")}
              key={index}
              onClick={() => toggleFAQ(index)}>
              <div className="faq-question">{t(faq.question)}</div>
              <div className="faq-answer">{t(faq.answer)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
